module Environments {
    module.directive("agentGroupListItem", function () {
        return {
            templateUrl: "AgentGroupListItemTemplate"
        };
    });
}